import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeletePostMutationVariables = Types.Exact<{
  postId: Types.Scalars['String']['input'];
  channelId: Types.Scalars['String']['input'];
}>;


export type DeletePostMutation = { deletePost: { success?: boolean | null } };


export const DeletePostDocument = /*#__PURE__*/ gql`
    mutation deletePost($postId: String!, $channelId: String!) {
  deletePost(data: {postId: $postId, channelId: $channelId}) {
    success
  }
}
    `;

export function useDeletePostMutation() {
  return Urql.useMutation<DeletePostMutation, DeletePostMutationVariables>(DeletePostDocument);
};